import React, { createContext } from 'react';
import { ISettingsAccountsDto } from '@shared/api';
import { emptyFunc } from '@shared/react';
import { PaginationOptions } from '@features/Pagination';
import { AccountAction } from '../';
import { IAccountsDesc } from './AccountsTableProvider';

export interface IAccountsTableContext {
    accounts: ISettingsAccountsDto[];
    accountStatuses: string[];
    accountMarginTypes: string[];
    accountsLoading: boolean;
    paginationOptions: PaginationOptions | null;
    desc: IAccountsDesc | null;
    sortFieldName: string;
    handleAccountsSort: (fildName: string) => void;
    accountsRefresh: () => void;
    isError: string;
    isInventory: string;
    onAccountViewClick: (id: ISettingsAccountsDto) => void;
    onAccountActionClick: (
        account: ISettingsAccountsDto,
        action: AccountAction,
        refresh: () => void,
        AdditionalComponent?: React.FC | null,
    ) => void;
    setCan: (clearingAccount: string) => void;
    setFdid: (fdid: string) => void;
    setAccountStatuses: (statuses: string[]) => void;
    setAccountMarginTypes: (types: string[]) => void;
    setIsError: (status: string) => void;
    setIsInventory: (status: string) => void;
}

export const AccountsTableContext = createContext<IAccountsTableContext>({
    accounts: [],
    accountStatuses: [],
    accountMarginTypes: [],
    accountsLoading: false,
    paginationOptions: null,
    desc: null,
    sortFieldName: '',
    handleAccountsSort: emptyFunc,
    accountsRefresh: emptyFunc,
    isError: 'false',
    isInventory: 'false',
    onAccountViewClick: emptyFunc,
    onAccountActionClick: emptyFunc,
    setCan: emptyFunc,
    setFdid: emptyFunc,
    setAccountStatuses: emptyFunc,
    setAccountMarginTypes: emptyFunc,
    setIsError: emptyFunc,
    setIsInventory: emptyFunc,
});
